import { Button, Text } from '@/ui-kit'
import { useNavigate } from 'react-router-dom'
import { useMissionsList } from '../api'
import { useMissionsUrl } from '../context/MissionsUrlProvider'

export const MissionNotAvailable = ({ reason }: { reason: 'unavailable' | 'profile_required' }) => {
  const { missionDetailsUrl, profileUrl, missionsUrl, platform } = useMissionsUrl()

  const navigate = useNavigate()
  const { data: missions = [] } = useMissionsList({ platform })
  const profileMission = missions?.find((mission) => mission.type === 'PROFILE')

  return (
    <div className="max-mobile:max-w-[calc(100vw-40px)] m-auto mt-10 flex w-[600px] flex-col items-center justify-center gap-4 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
      {reason === 'profile_required' ? (
        <>
          <Text type="h5" className="text-gray-70">
            Unlock This Mission
          </Text>
          <div className="flex flex-col items-center justify-center">
            <Text type="body1-regular" className="text-gray-80">
              Complete your profile to get started on this mission.
            </Text>
          </div>
          <Button
            size="small"
            onClick={() =>
              navigate(profileMission ? missionDetailsUrl.replace(':id', profileMission?.id ?? '') : profileUrl)
            }
            className="mt-2"
          >
            Complete Profile
          </Button>
        </>
      ) : (
        <>
          <Text type="h5" className="text-gray-70">
            Mission at Full Capacity
          </Text>
          <div className="flex flex-col items-center justify-center">
            <Text type="body1-regular" className="text-gray-80">
              All participation for this mission has been allocated. Availability may change, so please check again
              later.
            </Text>
          </div>
          <Button size="small" variant="bordered" onClick={() => navigate(missionsUrl)} className="mt-2">
            Back to Missions
          </Button>
        </>
      )}
    </div>
  )
}
